import ko from 'knockout';

export class FileViewModel {
    id: string;
    name: string;
}

export class FileInputModel {
    file: KnockoutObservable<any>;

    constructor() {
        this.file = ko.observable<any>();
    }
}

export class FileModel {
    id: KnockoutObservable<string>;
    name: KnockoutObservable<string>;

    constructor(model: any) {
        this.id = ko.observable<string>(model.id);
        this.name = ko.observable<string>(model.name);
    }
}
